const translations = {
  en: {
    // Nav
    nav: {
      home: "Home",
      about: "About",
      platform: "Platform",
      getInvolved: "Get Involved",
      contact: "Contact",
      donate: "Donate",
      forMayor: "for Mayor",
    },
    // Hero
    hero: {
      location: "Miramichi, New Brunswick",
      name: "Shawn Power",
      forMayor: "for Mayor",
      slogan: '"The time for debate has passed. The time for action is now."',
      tagline: "Miramichi resident. Not a politician.",
      ctaPlatform: "See the Platform",
      ctaJoin: "Join the Movement",
      scroll: "Scroll",
    },
    // About
    about: {
      label: "About the Candidate",
      heading: "Meet Shawn Power",
      bio: "Shawn Power isn't a career politician — he's your neighbour. A proud father of two, stepfather to two more, and loving grandfather of three, Shawn shares his life with his wife Margie, whose partnership is a constant source of strength and joy.",
      bio2: "An Electrical Engineering Technologist by trade, Shawn dedicated 21 years to Repap/UPM (1986–2007), building a strong foundation of technical expertise and professional commitment. In his younger years, he volunteered extensively with his church and local school — community service has always been in his nature.",
      bio3: "After the closure of the mills and the life changes that followed, Shawn stepped back from volunteering, but his passion for giving back never faded. He firmly believes volunteering is essential to a healthy community and is ready to channel that energy into leading Miramichi forward.",
      bio4: "Shawn currently resides in the former village of Nowlanville, near the southwest corner of the city, where he continues to value family, community, and the importance of contributing to the greater good.",
      bioPlaceholder: "",
      coreBeliefs: "Core Beliefs",
      beliefs: [
        "We have too much oversight from government.",
        "Our taxes are too high.",
        "New infrastructure should come from an increased tax base, not increased taxes.",
        "Politically motivated decision making is not good for Miramichi.",
      ],
    },
    // Platform
    platform: {
      label: "The Platform",
      heading: "Real Plans for Miramichi",
      subtitle: "No political playbook. Just common sense. Here's what Shawn will fight for as your mayor.",
      items: [
        {
          title: "The Planning Commission",
          summary: "Creating an in-house planning commission that works for you, not against you.",
          detail: "The city needs its own in-house planning commission with a liaison who works directly with people requiring their services. Anyone wanting to spend money growing this city should only have positive experiences. We cannot afford to have new businesses turn away because of bad experiences or a bad reputation.",
        },
        {
          title: "Your Tax Dollars",
          summary: "All spending under the microscope — tax increases held to a minimum.",
          detail: "It may not always be possible, but I believe that any additional tax revenue should come from growth in the tax base, rather than from increasing tax rates.\n\nThe best thing I can do for the citizens of Miramichi is put all spending under the microscope, so that tax increases are held to an absolute minimum.",
        },
        {
          title: "Veterans",
          summary: "Protecting our veterans' memorials — forever.",
          detail: "We will create a bylaw that directly states how we, the citizens, feel about our veterans. Under no future circumstances can our veterans' memorials be removed, covered or defaced due to changing ideals or beliefs. It is important that our pride in our veterans is forever evident for all future generations to know, not just on Remembrance Day.",
        },
        {
          title: "Northern Bypass",
          summary: "A new northern street now — not years from now.",
          detail: "We can connect the asphalt between Beaverbrook Road and McKinnon Road for immediate temporary relief. There is 2.5 km between these roads. This can be accomplished in one construction season. This will be a new street for local traffic only, so that favorite shopping destinations can be accessed while we continue to lobby the province for a bypass.",
        },
        {
          title: "Centennial Bridge Sidewalk",
          summary: "Practical local solutions over $50M provincial projects.",
          detail: "The city could easily install bus stops at each end of the bridge and transport those waiting from one side to the other, free of charge, as the bus travels over on its regular route. This would save provincial taxpayers $50 million and provide a real solution for Miramichiers. We don't always have to rely on the province.",
        },
      ],
      councilQuote: '"This platform is only as good as the 8 candidates that you elect as councilors. Please vote for those candidates supporting this platform so that accomplishing the goals can be swift."',
    },
    // Video
    video: {
      label: "Our Community",
      heading: "The People Behind the Campaign",
      subtitle: "Shawn Power is surrounded by friends, family, and neighbours who believe in a better Miramichi. Watch and see the community that drives this movement.",
    },
    // Show Your Support (profile frame CTA)
    showYourSupport: {
      kicker: "Show Your Support",
      heading: "Wear the badge. Spread the word.",
      body: "Add the Power for Mayor frame to your Facebook or Instagram profile picture — as your temporary profile picture until election day. Every profile is a small billboard, and when your friends see it, they'll remember Shawn's name on their ballot.",
      bullet1: "Takes less than 30 seconds — right in your browser, no apps required.",
      bullet2: "Works on your phone or your computer.",
      bullet3: "Your photo never leaves your device — the whole thing happens privately.",
      cta: "Get your badge",
      imageAlt: "Example of the Power for Mayor profile picture frame",
    },
    // Get Involved
    getInvolved: {
      label: "Get Involved",
      heading: "This Campaign Belongs to You",
      volunteer: {
        title: "Volunteer",
        subtitle: "Help build a better Miramichi. Sign up to volunteer for the campaign — every hand makes a difference.",
        nameLabel: "Name *",
        namePlaceholder: "Your full name",
        emailLabel: "Email *",
        emailPlaceholder: "your@email.com",
        phoneLabel: "Phone",
        phonePlaceholder: "(506) 000-0000",
        messageLabel: "How can you help?",
        messagePlaceholder: "Door-to-door, signs, events, social media...",
        submit: "Sign Up to Volunteer",
        submitting: "Signing up...",
        errorRequired: "Please provide your name and email.",
        errorGeneric: "Something went wrong. Please try again.",
        successTitle: "Thank you!",
        successMessage: "We'll be in touch soon. Together, we'll make Miramichi better.",
      },
      donate: {
        title: "Donate",
        subtitle: "Your support fuels this campaign. Every dollar helps us reach more neighbours, put up more signs, and spread the message.",
        etransferTitle: "Donate via Interac e-Transfer",
        etransferDesc: "Send your donation directly through your bank's e-Transfer service to:",
        etransferLabel: "E-Transfer Email",
        etransferNote: "Please include your name in the e-Transfer message.",
        communityQuote: '"Together, we can make Miramichi the community we know it can be."',
      },
    },
    // Footer
    footer: {
      label: "Get In Touch",
      heading1: "Let's build a",
      heading2: "better Miramichi",
      heading3: "together.",
      subtitle: "Have questions, ideas, or want to get involved? Reach out directly — Shawn wants to hear from you.",
      phone: "Phone",
      email: "Email",
      facebook: "Facebook",
      facebookText: "Follow the Campaign",
      location: "Location",
      locationText: "Miramichi, New Brunswick",
      copyright: "Shawn Power for Mayor — Miramichi",
      contactForm: {
        heading: "Send a Message",
        nameLabel: "Name *",
        namePlaceholder: "Your name",
        emailLabel: "Email *",
        emailPlaceholder: "your@email.com",
        messageLabel: "Message *",
        messagePlaceholder: "Your question, idea, or feedback...",
        submit: "Send Message",
        submitting: "Sending...",
        errorRequired: "Please fill in all fields.",
        errorGeneric: "Something went wrong. Please try again.",
        successTitle: "Message sent!",
        successMessage: "Thanks for reaching out. We'll get back to you soon.",
      },
    },
    // Endorsements
    endorsements: {
      label: "Endorsements",
      heading: "What People Are Saying",
      subtitle: "Community voices backing Shawn Power for mayor.",
    },
  },
  fr: {
    // Nav
    nav: {
      home: "Accueil",
      about: "\u00C0 propos",
      platform: "Plateforme",
      getInvolved: "S'impliquer",
      contact: "Contact",
      donate: "Donner",
      forMayor: "pour maire",
    },
    // Hero
    hero: {
      location: "Miramichi, Nouveau-Brunswick",
      name: "Shawn Power",
      forMayor: "pour maire",
      slogan: "\u00AB Le temps des d\u00E9bats est pass\u00E9. Le temps d'agir, c'est asteure. \u00BB",
      tagline: "R\u00E9sident de Miramichi. Pas un politicien.",
      ctaPlatform: "Voir la plateforme",
      ctaJoin: "Joignez le mouvement",
      scroll: "D\u00E9filez",
    },
    // About
    about: {
      label: "\u00C0 propos du candidat",
      heading: "Rencontrez Shawn Power",
      bio: "Shawn Power est point un politicien de carri\u00E8re \u2014 c'est votre voisin. Fier p\u00E8re de deux enfants, beau-p\u00E8re de deux autres et grand-p\u00E8re aimant de trois petits-enfants, Shawn partage sa vie avec sa femme Margie, dont le partenariat est une source constante de force et de joie.",
      bio2: "Technologue en g\u00E9nie \u00E9lectrique de m\u00E9tier, Shawn a consacr\u00E9 21 ans \u00E0 Repap/UPM (1986\u20132007), b\u00E2tissant une solide fondation d'expertise technique et d'engagement professionnel. Dans ses jeunes ann\u00E9es, il a fait beaucoup de b\u00E9n\u00E9volat avec son \u00E9glise et l'\u00E9cole locale \u2014 le service communautaire a toujours \u00E9t\u00E9 dans sa nature.",
      bio3: "Apr\u00E8s la fermeture des usines et les changements de vie qui ont suivi, Shawn s'est \u00E9loign\u00E9 du b\u00E9n\u00E9volat, mais sa passion pour redonner \u00E0 la communaut\u00E9 s'est jamais \u00E9teinte. Il croit fermement que le b\u00E9n\u00E9volat est essentiel \u00E0 une communaut\u00E9 en sant\u00E9 et il est pr\u00EAt \u00E0 canaliser cette \u00E9nergie pour mener Miramichi vers l'avant.",
      bio4: "Shawn r\u00E9side pr\u00E9sentement dans l'ancien village de Nowlanville, pr\u00E8s du coin sud-ouest de la ville, o\u00F9 il continue de valoriser la famille, la communaut\u00E9 et l'importance de contribuer au bien commun.",
      bioPlaceholder: "",
      coreBeliefs: "Convictions fondamentales",
      beliefs: [
        "On a trop de surveillance du gouvernement.",
        "Nos taxes sont trop hautes.",
        "Les nouvelles infrastructures devraient venir d'une base fiscale \u00E9largie, pas de taxes plus hautes.",
        "Les d\u00E9cisions motiv\u00E9es par la politique sont point bonnes pour Miramichi.",
      ],
    },
    // Platform
    platform: {
      label: "La plateforme",
      heading: "Des vrais plans pour Miramichi",
      subtitle: "Pas de livre de jeu politique. Juste du gros bon sens. Voici ce que Shawn va d\u00E9fendre comme votre maire.",
      items: [
        {
          title: "La Commission d'am\u00E9nagement",
          summary: "Cr\u00E9er une commission d'am\u00E9nagement interne qui travaille pour vous, pas contre vous.",
          detail: "La ville a besoin de sa propre commission d'am\u00E9nagement avec un agent de liaison qui travaille directement avec les gens qui ont besoin de ses services. Quiconque veut d\u00E9penser de l'argent pour faire cro\u00EEtre cette ville devrait avoir seulement des exp\u00E9riences positives. On peut pas se permettre que des nouvelles entreprises s'en vont \u00E0 cause de mauvaises exp\u00E9riences ou d'une mauvaise r\u00E9putation.",
        },
        {
          title: "Vos imp\u00F4ts",
          summary: "Toutes les d\u00E9penses \u00E0 la loupe \u2014 hausses de taxes r\u00E9duites au minimum.",
          detail: "Ce n'est pas toujours possible, mais je crois que tout revenu de taxe suppl\u00E9mentaire devrait venir de la croissance de la base fiscale, pas d'une augmentation des taux de taxe.\n\nLa meilleure chose que je peux faire pour les citoyens de Miramichi, c'est de mettre toutes les d\u00E9penses \u00E0 la loupe, pour que les hausses de taxes soient r\u00E9duites au minimum absolu.",
        },
        {
          title: "Les v\u00E9t\u00E9rans",
          summary: "Prot\u00E9ger les m\u00E9moriaux de nos v\u00E9t\u00E9rans \u2014 pour toujours.",
          detail: "On va cr\u00E9er un r\u00E8glement qui dit clairement comment nous, les citoyens, on se sent envers nos v\u00E9t\u00E9rans. En aucune circonstance future, les m\u00E9moriaux de nos v\u00E9t\u00E9rans pourront \u00EAtre enlev\u00E9s, couverts ou d\u00E9figur\u00E9s \u00E0 cause de changements d'id\u00E9aux ou de croyances. C'est important que notre fiert\u00E9 envers nos v\u00E9t\u00E9rans soit \u00E9vidente pour toujours, pour toutes les g\u00E9n\u00E9rations futures, pas juste le jour du Souvenir.",
        },
        {
          title: "Le contournement nord",
          summary: "Une nouvelle rue au nord maintenant \u2014 pas dans des ann\u00E9es.",
          detail: "On peut connecter l'asphalte entre le chemin Beaverbrook et le chemin McKinnon pour un soulagement temporaire imm\u00E9diat. Il y a 2,5 km entre ces routes. \u00C7a peut \u00EAtre accompli en une saison de construction. \u00C7a va \u00EAtre une nouvelle rue pour le trafic local seulement, pour que nos destinations de magasinage pr\u00E9f\u00E9r\u00E9es soient accessibles pendant qu'on continue de faire pression sur la province pour un contournement.",
        },
        {
          title: "Le trottoir du pont Centennial",
          summary: "Des solutions locales pratiques plut\u00F4t que des projets provinciaux de 50 M$.",
          detail: "La ville pourrait facilement installer des arr\u00EAts d'autobus \u00E0 chaque bout du pont et transporter ceux qui attendent d'un bord \u00E0 l'autre, gratuitement, pendant que le bus traverse sur sa route r\u00E9guli\u00E8re. \u00C7a sauverait aux contribuables provinciaux 50 millions de dollars et offrirait une vraie solution pour les gens de Miramichi. On n'a pas toujours besoin de d\u00E9pendre de la province.",
        },
      ],
      councilQuote: "\u00AB Cette plateforme est seulement aussi bonne que les 8 candidats que vous \u00E9lisez comme conseillers. S'il vous pla\u00EEt, votez pour les candidats qui supportent cette plateforme pour que l'accomplissement des buts soit rapide. \u00BB",
    },
    // Video
    video: {
      label: "Notre communaut\u00E9",
      heading: "Le monde derri\u00E8re la campagne",
      subtitle: "Shawn Power est entour\u00E9 d'amis, de famille et de voisins qui croient en un meilleur Miramichi. Regardez et voyez la communaut\u00E9 qui porte ce mouvement.",
    },
    // Show Your Support (profile frame CTA)
    showYourSupport: {
      kicker: "Montrez votre soutien",
      heading: "Portez le badge. Passez le mot.",
      body: "Ajoutez le cadre Power for Mayor \u00E0 votre photo de profil Facebook ou Instagram \u2014 comme photo de profil temporaire jusqu'au jour de l'\u00E9lection. Chaque profil, c'est un petit panneau publicitaire, et quand vos amis le voient, ils vont se rappeler du nom de Shawn sur leur bulletin.",
      bullet1: "\u00C7a prend moins de 30 secondes \u2014 directement dans votre navigateur, aucune app \u00E0 installer.",
      bullet2: "Marche sur votre t\u00E9l\u00E9phone ou sur votre ordinateur.",
      bullet3: "Votre photo ne quitte jamais votre appareil \u2014 tout se fait en priv\u00E9.",
      cta: "Obtenez votre badge",
      imageAlt: "Exemple du cadre de photo de profil Power for Mayor",
    },
    // Get Involved
    getInvolved: {
      label: "S'impliquer",
      heading: "Cette campagne vous appartient",
      volunteer: {
        title: "B\u00E9n\u00E9volat",
        subtitle: "Aidez \u00E0 b\u00E2tir un meilleur Miramichi. Inscrivez-vous comme b\u00E9n\u00E9vole pour la campagne \u2014 chaque coup de main fait la diff\u00E9rence.",
        nameLabel: "Nom *",
        namePlaceholder: "Votre nom complet",
        emailLabel: "Courriel *",
        emailPlaceholder: "votre@courriel.com",
        phoneLabel: "T\u00E9l\u00E9phone",
        phonePlaceholder: "(506) 000-0000",
        messageLabel: "Comment pouvez-vous aider?",
        messagePlaceholder: "Porte-\u00E0-porte, pancartes, \u00E9v\u00E9nements, m\u00E9dias sociaux...",
        submit: "S'inscrire comme b\u00E9n\u00E9vole",
        submitting: "Inscription en cours...",
        errorRequired: "S'il vous pla\u00EEt, fournissez votre nom et courriel.",
        errorGeneric: "Quelque chose a mal tourn\u00E9. Essayez encore.",
        successTitle: "Merci ben!",
        successMessage: "On va vous contacter bient\u00F4t. Ensemble, on va faire de Miramichi un meilleur endroit.",
      },
      donate: {
        title: "Donner",
        subtitle: "Votre support fait rouler cette campagne. Chaque dollar nous aide \u00E0 rejoindre plus de voisins, poser plus de pancartes et r\u00E9pandre le message.",
        etransferTitle: "Donnez par virement Interac",
        etransferDesc: "Envoyez votre don directement par le service de virement Interac de votre banque \u00E0 :",
        etransferLabel: "Courriel pour virement",
        etransferNote: "S'il vous pla\u00EEt, incluez votre nom dans le message du virement.",
        communityQuote: "\u00AB Ensemble, on peut faire de Miramichi la communaut\u00E9 qu'on sait qu'elle peut \u00EAtre. \u00BB",
      },
    },
    // Footer
    footer: {
      label: "Contactez-nous",
      heading1: "B\u00E2tissons un",
      heading2: "meilleur Miramichi",
      heading3: "ensemble.",
      subtitle: "Vous avez des questions, des id\u00E9es, ou vous voulez vous impliquer? Contactez-nous directement \u2014 Shawn veut vous entendre.",
      phone: "T\u00E9l\u00E9phone",
      email: "Courriel",
      facebook: "Facebook",
      facebookText: "Suivez la campagne",
      location: "Emplacement",
      locationText: "Miramichi, Nouveau-Brunswick",
      copyright: "Shawn Power pour maire \u2014 Miramichi",
      contactForm: {
        heading: "Envoyez un message",
        nameLabel: "Nom *",
        namePlaceholder: "Votre nom",
        emailLabel: "Courriel *",
        emailPlaceholder: "votre@courriel.com",
        messageLabel: "Message *",
        messagePlaceholder: "Votre question, id\u00E9e ou commentaire...",
        submit: "Envoyer le message",
        submitting: "Envoi en cours...",
        errorRequired: "S'il vous pla\u00EEt, remplissez tous les champs.",
        errorGeneric: "Quelque chose a mal tourn\u00E9. Essayez encore.",
        successTitle: "Message envoy\u00E9!",
        successMessage: "Merci de nous avoir \u00E9crit. On va vous r\u00E9pondre bient\u00F4t.",
      },
    },
    // Endorsements
    endorsements: {
      label: "Appuis",
      heading: "Ce que le monde dit",
      subtitle: "Des voix de la communaut\u00E9 qui appuient Shawn Power pour maire.",
    },
  },
};

export default translations;
